import { ApiInstance } from "@/api";

import { type AxiosResponse } from "axios";

export default class QZ_TRAY_API {
  static async getKey(): Promise<AxiosResponse<string>> {
    return await ApiInstance.get("/Qz/key");
  }

  static async signMessage(request: string): Promise<AxiosResponse<string>> {
    return ApiInstance.post<string>("/Qz/key", request, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  static async getInstaller(): Promise<AxiosResponse<Blob>> {
    return ApiInstance.get("/Qz/qzfile", {
      responseType: "blob",
    });
  }
}
